import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    defaultMessage:
      'The package types enabled in the list below will appear in your Package drop-down menu when configuring your shipments. To remove package types you do not use, select the carrier from the Manage package types drop-down menu, deselect the package from the list, and click Save Changes.',
    id: 'jjERlB',
    description: 'settings.packages-page.carrier-packages.description',
  },
  'menu-label': {
    defaultMessage: 'Manage package types',
    id: 'dlFNmv',
    description: 'settings.packages-page.carrier-packages.menu-label',
  },
  noCarriersBannerMessage: {
    defaultMessage: 'To configure Carrier Packages, first <link>add some Carriers</link>.',
    id: 'GEdwYb',
    description: 'Notifies the user that they need to set up a carrier to enable package types',
  },
});

export const tableMessages = {
  headers: defineMessages({
    name: {
      defaultMessage: 'Name',
      id: 'm8whpX',
      description: 'settings.packages-page.carrier-packages.table.header1',
    },
  }),
  ariaLabels: defineMessages({
    selectAllPackages: {
      defaultMessage: 'Select all packages',
      id: 'Nm+raU',
      description: 'Aria label for checkbox to select all carrier packages',
    },
    deselectAllPackages: {
      defaultMessage: 'Deselect all packages',
      id: 'SoIU/1',
      description: 'Aria label for checkbox to deselect all carrier packages',
    },
    selectPackage: {
      defaultMessage: 'Select package {packageName}',
      id: 'yNyGu3',
      description: 'Aria label for checkbox to select a specific carrier package',
    },
    deselectPackage: {
      defaultMessage: 'Deselect package {packageName}',
      id: 'ljz6co',
      description: 'Aria label for checkbox to deselect a specific carrier package',
    },
  }),
};
